'use client';

import { Divider } from '@heroui/react';
import { useAction, useAtom } from '@reatom/npm-react';
import { gtEstiPro, manrope } from '@trwl/app/fonts';
import { Container } from '@trwl/layout';
import { Path } from '@trwl/shared/lib/router';
import { Button } from '@trwl/shared/ui/button';
import { Title } from '@trwl/shared/ui/title';
import { cartAtom, loadCartDataAction, updateCartAction } from '@trwl/store';
import { formatNumber } from '@trwl/util';
import { Cart } from '@trwl/widgets/product/cart';
import cn from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useEffect, useMemo } from 'react';

import { InfoTooltip } from '../../widgets/product/infoTooltip';

export const CartPage = () => {
  const [cart] = useAtom(cartAtom);
  const updateCart = useAction(updateCartAction);
  const loadCartData = useAction(loadCartDataAction);
  const router = useRouter();

  useEffect(() => {
    const timeout = setTimeout(() => {
      updateCart();
    }, 500);
    return () => clearTimeout(timeout);
  }, [updateCart]);

  useEffect(() => {
    const loadData = () => {
      loadCartData();
    };
    loadData();
    const interval = setInterval(loadData, 3000);
    return () => clearInterval(interval);
  }, [loadCartData]);

  const fullPrice = useMemo(() => {
    return cart
      .map(
        (product) => (product.price + product.deliveryAmount) * product.count,
      )
      .reduce((acc, cur) => acc + cur, 0);
  }, [cart]);

  return (
    <Container>
      <div className="mt-4 flex flex-col items-start md:items-center w-full">
        <Title>Корзина</Title>
        <div className="w-full grid grid-cols-1 lg:grid-cols-3 justify-between gap-16">
          <div className="w-full lg:col-span-2">
            {cart.length ? (
              <Cart cart={cart} withCounter />
            ) : (
              <div>
                <h2 className="text-[22px]">
                  Ваша корзина пуста,{' '}
                  <Link href={Path.CATALOG} className="underline text-center">
                    перейти к покупкам?
                  </Link>
                </h2>
              </div>
            )}
          </div>
          {cart.length > 0 && (
            <div
              className={cn(
                'w-full flex flex-col gap-[25px]',
                manrope.className,
              )}
            >
              <div className="text-[22px] mb-[5px]">Сумма заказа</div>
              <div className="flex flex-col gap-[15px] text-[18px] text-[#282828]">
                <div className="flex justify-between items-center">
                  <div>Товары</div>
                  <div>{formatNumber(fullPrice)} ₽</div>
                </div>
                <div className="flex justify-between items-center">
                  <div>Доставка</div>
                  <div>0 ₽</div>
                </div>
                <div className="flex justify-between items-center">
                  <div>Промокод</div>
                  <div>При оплате</div>
                </div>
              </div>
              <div className="flex flex-col gap-[25px]">
                <Divider />
                <div
                  className={
                    'flex justify-between items-center text-[20px] font-bold text-[#282828]'
                  }
                >
                  <div>
                    <span className={'mr-2'}>Итого</span>
                    <InfoTooltip>
                      Цена указана с учетом доставки до Москвы
                    </InfoTooltip>
                  </div>
                  <div className={gtEstiPro.className}>
                    {formatNumber(fullPrice)} ₽
                  </div>
                </div>
                <Button
                  onPress={() => router.push(Path.ORDER)}
                  fullWidth
                  radius={'sm'}
                  size={'lg'}
                  color={'primary'}
                  className={'whitespace-nowrap'}
                >
                  Оформить заказ
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};
